import { createContext } from 'react';

import {
  useGroupByShiftFilter,
  usePersistedParam,
} from '@sbv-clients/domain-ui-shared';

import { TabSelection } from '../../../components/employees-stats-header';

const pageKey = 'FacilityStatus';
export const useFacilityStatusContext = () => {
  const [tab, setTab] = usePersistedParam({
    pageKey,
    paramKey: 'tab',
    type: 'number',
    defaultValue: TabSelection.all,
  });
  const [groupByShift, setGroupByShift] = useGroupByShiftFilter(pageKey);
  const [filterByWeekend, setFilterByWeekend] = usePersistedParam({
    pageKey,
    paramKey: `filterByWeekend`,
    type: 'boolean',
  });

  return {
    tab,
    setTab,
    groupByShift,
    setGroupByShift,
    filterByWeekend,
    setFilterByWeekend,
  };
};

export type FacilityStatusContextType = ReturnType<
  typeof useFacilityStatusContext
>;

export const FacilityStatusContext =
  createContext<FacilityStatusContextType | null>(null);
